import { useAppearance } from '~/data/appearance';
import { useModulesConfig } from '~/data/company';
import { useCompanyData } from '~/data/company/useCompanyData';
import {
  allPortalDataDispatchReduxFetches,
  portalMinimumDataDispatchReduxFetches,
  useInitializeCommonReduxData,
} from '~/hooks/initializeData/useInitializeCommonReduxData';
import { AppModules } from '~/services/Permissions';

export const usePortalViews = () => {
  const companyDataState = useCompanyData();
  const { isModuleEnabled } = useModulesConfig();
  const isAIChatbotEnabled = isModuleEnabled(AppModules.AI_CHATBOT);

  const appearanceState = useAppearance();

  const {
    requiredStatus: { isInitializing, percentage },
  } = useInitializeCommonReduxData({
    required: portalMinimumDataDispatchReduxFetches,
    preload: allPortalDataDispatchReduxFetches,
  });

  const isLoading =
    (appearanceState.isEnabled && appearanceState.isLoading) ||
    (!companyDataState.hasData && companyDataState.isLoading);

  return {
    initializationPercentage: percentage,
    isInitializing,
    isLoading,
    isAIChatbotEnabled,
  };
};
